<div class="bottom-actions">
  <div class="new-model-name">
    <label>{{ nameLabelKey | translate }}</label>
    <input
      [ngModel]="modelName"
      (ngModelChange)="modelNameChange.emit($event)"
      [placeholder]="namePlaceholderKey ? (namePlaceholderKey | translate) : ''" />
  </div>

  <div class="action-buttons">
    @if (showWarning) {
      <span class="no-archives-warning">
        <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
        {{ warningLabelKey | translate }}
      </span>
    }
    <button class="secondary-btn" [disabled]="saveDisabled || saving" (click)="save.emit()">
      @if (saving) {
        <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
      }
      {{ (saveLabelKey | translate) + (markSaveChanges && hasChanges ? ' *' : '') }}
    </button>
    @if (showSaveAndExecute) {
      <button class="primary-btn" [disabled]="executeDisabled || executing" (click)="saveAndExecute.emit()">
        <fa-icon [icon]="icons.faBolt"></fa-icon>
        {{ saveAndExecuteLabelKey | translate }}
      </button>
    }
    @if (showExecute) {
      <button class="primary-btn" [disabled]="executeDisabled || executing" (click)="execute.emit()">
        @if (executing) {
          <fa-icon [icon]="icons.faSpinner" animation="spin"></fa-icon>
        } @else {
          <fa-icon [icon]="icons.faBolt"></fa-icon>
        }
        {{ executeLabelKey | translate }}
      </button>
    }
  </div>
</div>
